import http from './http';

export interface MeResponseAuthenticated {
  authenticated: true;
  user: {
    sub: string;
    name: string;
    email?: string | null;
    roles: string[];
    tenant_key?: string | null;
    exp: number;
  };
}
export interface MeResponseAnonymous {
  authenticated: false;
}
export type MeResponse = MeResponseAuthenticated | MeResponseAnonymous;

export async function fetchMe(): Promise<MeResponse> {
  const r = await http.get<MeResponse>('/api/me');
  return r.data;
}

export async function logout(): Promise<void> {
  await http.post('/auth/logout');
}

/** Build the /auth/login URL with return_to so passport can come back here. */
export function ssoLoginHref(returnTo: string = '/dashboard'): string {
  const safe = returnTo.startsWith('/') ? returnTo : '/dashboard';
  return `/auth/login?return_to=${encodeURIComponent(safe)}`;
}

/** Dev-only: POST /auth/dev-login. Throws AxiosError when 404 (prod build). */
export async function devLogin(sub: string, name: string, roles: string[]): Promise<MeResponse> {
  const r = await http.post('/auth/dev-login', { sub, name, roles });
  return { authenticated: true, user: r.data.user };
}
